import { Component } from 'opus-angular-seed-core';
import imageIcon from 'lucide-static/icons/image.svg';
import videoIcon from 'lucide-static/icons/video.svg';
import uploadIcon from 'lucide-static/icons/upload.svg';
import refreshCcwIcon from 'lucide-static/icons/refresh-ccw.svg';
import xIcon from 'lucide-static/icons/x.svg';
import template from './template.html';

@Component({
    bindings: {
        type: '<',
        file: '=',
        existingUrl: '<',
        onRemove: '&',
        onNewFile: '&'
    },
    template
})
export default class {
    constructor ($sce, $translate) {
        this.$sce = $sce;
        this.$translate = $translate;
        this.uploadIconHtml = $sce.trustAsHtml(uploadIcon);
        this.refreshIconHtml = $sce.trustAsHtml(refreshCcwIcon);
        this.xIconHtml = $sce.trustAsHtml(xIcon);
    }

    $onInit () {
        if (!this.type) {
            this.type = 'image';
        }
        this._updateDerivedProps();
    }

    $onChanges () {
        this._updateDerivedProps();
    }

    _updateDerivedProps () {
        const isImg = this.isImage();
        this.accept = isImg ? 'image/png,image/jpeg' : 'video/mp4,video/webm,video/ogg,.ogg,.ogv';
        this.dropHint = this.$translate.instant(isImg ? 'mediaUpload.dropImageHint' : 'mediaUpload.dropVideoHint');
        this.formatHint = this.$translate.instant(isImg ? 'mediaUpload.imageFormatHint' : 'mediaUpload.videoFormatHint');
        this.mediaIconHtml = this.$sce.trustAsHtml(isImg ? imageIcon : videoIcon);
    }

    isImage () {
        return (this.type || 'image') === 'image';
    }

    getFileSizeFormatted () {
        if (!this.file) return '';
        const size = this.file.size;
        if (size < 1024) return `${size} B`;
        if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
        return `${(size / (1024 * 1024)).toFixed(1)} MB`;
    }

    isExistingPreview () {
        return !!this.existingUrl && !this.file;
    }

    showReplaceButton () {
        return !!this.file;
    }

    onFileSelected (file) {
        if (!file) return;
        this.file = file;
        this._updateDerivedProps();
        if (this.onNewFile) {
            this.onNewFile({ $file: file });
        }
    }

    removeFile () {
        if (this.isExistingPreview() && this.onRemove) {
            this.onRemove();
            return;
        }
        this.file = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/mediaUpload/index.js